import React, { Children } from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
export function HowItWorksSection() {
  return <AnimatedSection staggerChildren className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-179">
      <div className="text-center mb-16" data-id="element-180">
        <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-181">
          Cómo Funciona
        </h2>
      </div>

      <div className="space-y-8" data-id="element-182">
        <AnimatedItem data-id="element-183">
          <div className="bg-cream rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center relative overflow-hidden" data-id="element-184">
            <div className="absolute -right-4 -top-4 text-9xl font-heading font-bold text-warmBg opacity-50 select-none" data-id="element-185">
              1
            </div>
            <div className="bg-sage text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0 relative z-10" data-id="element-186">
              1
            </div>
            <div className="relative z-10" data-id="element-187">
              <h3 className="text-xl font-bold text-charcoal mb-2 font-heading" data-id="element-188">
                Descarga el material
              </h3>
              <p className="text-charcoal/70 text-lg" data-id="element-189">
                Inmediatamente después de tu compra recibes acceso a todo el
                contenido.
              </p>
            </div>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-190">
          <div className="bg-cream rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center relative overflow-hidden" data-id="element-191">
            <div className="absolute -right-4 -top-4 text-9xl font-heading font-bold text-warmBg opacity-50 select-none" data-id="element-192">
              2
            </div>
            <div className="bg-sage text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0 relative z-10" data-id="element-193">
              2
            </div>
            <div className="relative z-10" data-id="element-194">
              <h3 className="text-xl font-bold text-charcoal mb-2 font-heading" data-id="element-195">
                Escucha la audio-guía
              </h3>
              <p className="text-charcoal/70 text-lg" data-id="element-196">
                Familiarízate con los "resets" biológicos y cómo activarlos.
              </p>
            </div>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-197">
          <div className="bg-cream rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center relative overflow-hidden" data-id="element-198">
            <div className="absolute -right-4 -top-4 text-9xl font-heading font-bold text-warmBg opacity-50 select-none" data-id="element-199">
              3
            </div>
            <div className="bg-sage text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0 relative z-10" data-id="element-200">
              3
            </div>
            <div className="relative z-10" data-id="element-201">
              <h3 className="text-xl font-bold text-charcoal mb-2 font-heading" data-id="element-202">
                Activa el protocolo
              </h3>
              <p className="text-charcoal/70 text-lg" data-id="element-203">
                La próxima vez que sientas ansiedad, recupera el control en
                segundos.
              </p>
            </div>
          </div>
        </AnimatedItem>
      </div>
    </AnimatedSection>;
}